// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-2-kEp";
var _3 = "header__icon-9OEHD";
var _4 = "root-19PY7";
var _5 = "root_seats-1B7Or";
var _6 = "root_baggage-1VnZE";
var _7 = "root_insurance-1I1YJ";
var _8 = "header__title-tGNRF";
var _9 = "options-3JYgP";
export { _1 as "__esModule", _2 as "header", _3 as "header__icon", _4 as "root", _5 as "root_seats", _6 as "root_baggage", _7 as "root_insurance", _8 as "header__title", _9 as "options" }
export default { "__esModule": _1, "header": _2, "header__icon": _3, "root": _4, "root_seats": _5, "root_baggage": _6, "root_insurance": _7, "header__title": _8, "options": _9 }
